import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import useSettings from '../hooks/useSettings';
import getDateLocale from '../utils/getDateLocale';

// Import to ensure i18n is initialized
import '../locales/i18n';

I18nProvider.propTypes = {
  children: PropTypes.node,
};

export default function I18nProvider({ children }) {
  const { i18n } = useTranslation();
  const { themeLanguage, onChangeLanguage } = useSettings();

  // Sync SettingsContext -> i18next
  useEffect(() => {
    if (themeLanguage && themeLanguage !== i18n.language) {
      i18n.changeLanguage(themeLanguage);
    }
  }, [themeLanguage]);

  // Sync i18next -> SettingsContext
  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      if (lng !== themeLanguage) {
        onChangeLanguage(lng);
      }
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [themeLanguage, onChangeLanguage]);

  const dateLocale = getDateLocale();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateLocale}>
      {children}
    </LocalizationProvider>
  );
}
